import "slick-carousel";

let getDefaultColor = item => {
    let defaultProductColor = false;
    let arrayImages = [];
    let onlyGalleryImages = fiterImages(window.PRODUCT_IMAGES[item.dataset.id]);

    onlyGalleryImages.forEach(function(value) {
        if (!defaultProductColor) {
            defaultProductColor = getColorString(value[2]);
        }
        if (getColorString(value[2]) === defaultProductColor) {
            arrayImages.push(value);
        }
    });
    generateSliderHTML(arrayImages, item);
    generateSlider(item);
    $(item).data("array_images", onlyGalleryImages);
};

let fiterImages = arrObj => {
    let onlyBelowImages = [];
    let onlyGalleryImages = [];
    arrObj.forEach(function(value) {
        const valueArray = value[2].split("|");
        const handledValue = valueArray[valueArray.length - 1].trim().toLowerCase();

        if (handledValue === "gallery") {
            onlyGalleryImages.push(value);
        } else if (handledValue === "below") {
            onlyBelowImages.push(value);
        }
    });

    return onlyGalleryImages;
    // console.log(onlyGalleryImages);
    // console.log(onlyBelowImages);
};

let generateSliderHTML = (slides, item) => {
    let html = "";
    item.innerHTML = "";
    if (item.classList.contains("slick-initialized")) {
        item.classList.remove("slick-initialized", "slick-slider", "slick-dotted");
    }
    slides.forEach(function(slide) {
        html +=
            '<div class="product__image">' +
            '<a href="' +
            slide[1] +
            '">' +
            '<img src="' +
            slide[0] +
            '" alt="' +
            slide[2] +
            '">' +
            "</a>" +
            "</div>";
    });
    item.innerHTML = html;
};

let generateSlider = item => {
    $(item).slick({
        dots: true,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        swipe: true
    });
};

if ($(window).width() < 768) {
    $(".product__bundle .mobile-images").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        dots: true,
        asNavFor: ".product__bundle .product__bundle-col:eq(1)"
    });

    $(".product__bundle .product__bundle-col:eq(1)").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: ".product__bundle .mobile-images"
    });
}

$(".collection-row .collection-row__inner").slick({
    slidesToShow: 3,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    dots: false,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2
            }
        }
    ]
});

let getColorString = value => {
    let first = value.split("|")[0];
    let result;
    if (first.indexOf("color:") > -1) {
        result = first.split("color:")[1];
    } else if (first.indexOf("colour:") > -1) {
        result = first.split("colour:")[1];
    }
    return result.trim().replace(/\s/g, "-");
};

let changeGallery = (color, item) => {
    let arrayImages = [];
    $(item).data("array_images").forEach(function(value) {
        if (getColorString(value[2]) === color) {
            arrayImages.push(value);
        }
    });
    generateSliderHTML(arrayImages, item[0]);
    generateSlider(item);
};

let generateFirstSliderRelatedProducst = () => {
    $("#product_slider__second, #product_slider__first").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        dots: false,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $(".product__bundle ul li").on("click", function() {
        $(".product__bundle ul li").removeClass("active");
        $(this).addClass("active");
        $(".product__also-like__body ul li").removeClass("active");
        $(".product__also-like__body ul li:eq(" + $(this).index() + ")").addClass("active");
    });

    // let idProducts = []
    // let idProducts = $("#relatedProductsData").data('related-ids').split(',');
    // let sliderHTML = '<div clas="collection__listing">';
    // sliderHTML += '<div class="product-box">'+
    // '<a href="/products/aaron-short-jacket-in-cotton-denim" class="product-box__image" style="background-image: url(//cdn.shopify.com/s/files/1/0102/4045/8810/products/ci_268641_1024x.png?v=1538037499)"><span style="background-image: url(//cdn.shopify.com/s/files/1/0102/4045/8810/products/ci_268647_1024x.png?v=1538037499)"></span></a>'+
    // '<div class="product-box__overlay">'+
    //     '<div class="product-box__inner">'+
    //     '<div class="left-box">'+
    //         '<h5>Akris</h5>'+
    //         '<h4><a href="/products/aaron-short-jacket-in-cotton-denim">AARON Short jacket in cotton denim</a></h4>'+
    //     '</div><!-- /.left-box -->'+
    //     '<div class="right-box">'+
    //         '<!-- favourite -->'+
    //         '<p class="price">€1.790,00</p><!-- /.price -->'+
    //     '</div><!-- /.right-box --><div class="radios-holder">'+
    //         '<span class="hover-item"></span><div class="radio__holder">'+
    //             '<input type="radio" name="color-1863269056570" value="black">'+
    //             '<label class="color--black"></label>'+
    //             '</div><!-- /.radio__holder --><div class="radio__holder">'+
    //             '<input type="radio" name="color-1863269056570" value="teal">'+
    //             '<label class="color--teal"></label>'+
    //             '</div><!-- /.radio__holder --></div><!-- /.radios-holder --></div><!-- /.product-box__inner -->'+
    //     '</div><!-- /.product-box__overlay -->'+
    // '</div>'
    // sliderHTML += '</div>';
};

(function() {
    const sliderDOM = document.querySelectorAll(".target_gallery");
    sliderDOM.forEach(function(item) {
        getDefaultColor(item);
    });
    generateFirstSliderRelatedProducst();
})();

module.exports = {
    changeGallery
};



// WEBPACK FOOTER //
// ../assets/js/product_gallery.js